module.exports = __webpack_public_path__ + "img/admision2027mobile-2.ee8ca8c8.webp";